var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmniWhiteSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 372.81 301.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "omni-white-symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324,136.21,15.1,10.2a2.21,2.21,0,0,0-2,3.9L237.62,144A57,57,0,0,1,257,219.84l-38.09,68.8a2,2,0,0,0,1.75,3h84a5,5,0,0,0,4.19-2.27L351,224.82A60.43,60.43,0,0,0,324,136.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.23,146.48,19.09,27.79a3.43,3.43,0,0,0-3.95,5.57L152.62,148.45a67.86,67.86,0,0,1,18.16,80.27l-27.45,60.06a2,2,0,0,0,1.82,2.83h58.76A3,3,0,0,0,206.6,290l34.51-69A56.94,56.94,0,0,0,219.23,146.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.57,161.81,20.82,49.46a2.87,2.87,0,0,0-4.15,3.94L102,164.69a73.49,73.49,0,0,1,11.24,69L94.05,289a2,2,0,0,0,1.89,2.66H130a3,3,0,0,0,2.8-1.93l24-62.61A58.68,58.68,0,0,0,140.57,161.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmniWhiteSymbol);
export default __webpack_public_path__ + "static/media/omni-white-symbol.a6ec726cfe95e61cc246c0de6b0b4fbe.svg";
export { ForwardRef as ReactComponent };